import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import makeSeveralCurrentsModule from '@/store/severalCurrentsModule';
import setTechnicianAffected from '@/store/modules/requests/setTechnicianAffected';
import RequestsService from '@/services/services/requests.service';
import { PURPOSE_LIST } from '@/store/modules/properties/constants';

const attributesObj = {
  dispatched: {
    serverSide: true,
    values: ['N'],
  },
  rejected: {
    serverSide: true,
    values: ['N'],
  },
  status: {
    serverSide: true,
    values: ['1'],
  },
  his_treatment: {
    serverSide: true,
    values: [],
    type: '$is~PEM',
  },
  work_order_group_type_name: {
    serverSide: true,
    values: [],
    type: '$instr',
  },
  customer_name: {
    serverSide: true,
    values: [],
    type: '$instr',
  },
  request_customer_type: {
    serverSide: true,
    values: [],
  },
};

const attributesObjRef = {
  his_treatment: {
    serverSide: true,
    values: [
      {
        id: true,
        name: 'PEM',
      },
      {
        id: false,
        name: 'Dispatcheur',
      },
    ],
    type: '$is~PEM',
  },

  transformable_request: {
    serverSide: true,
    values: [
      {
        id: 'O',
        name: 'Oui',
      },
      {
        id: 'N',
        name: 'Non',
      },
    ],
  },
  customer_type: {
    autocomplete: true,
    serverSide: true,
    values: [
      { id: 'CLI', name: 'CLI - Client' },
      { id: 'CRG', name: 'CRG - Concierge' },
      { id: 'POR', name: 'POR - Portail Client' },
      { id: 'LOC', name: 'LOC - Locataire - propiétaire' },
      { id: 'TEC', name: 'TEC - Technicien' },
      { id: 'TTS', name: 'TTS - Transmetteur de télésurveillance' },
      { id: 'SST', name: 'SST - Société de surveillance' },
      { id: 'XXX', name: 'XXX - Autre' },
    ],
  },
  purpose: {
    autocomplete: true,
    serverSide: true,
    values: PURPOSE_LIST,
  },
  work_order_group_type_name: {
    noFilter: true,
    type: '$instr',
    values: [],
  },
  customer_name: {
    noFilter: true,
    type: '$instr',
    values: [],
  },
  request_customer_type: {
    serverSide: true,
    autocomplete: true,
    values: [
      { id: 'STANDARD', name: 'Standard' },
      { id: 'AUTO', name: 'Auto' },
      { id: 'PREMIUM', name: 'Premium' },
    ],
  },
};

function SET_ALERTS(state, alertsList) {
  let items = state.items.data;
  items = items.map((item) => ({
    ...item,
    alerts: alertsList.find((alert) => alert.property_id === item.property_id),
  }));
  state.items.data = items;
}

function SET_RECURRENCE(state, recurrenceList) {
  let items = state.items.data;
  items = items.map((item) => {
    const recurrenceItem = recurrenceList.find(
      (recurrence) => recurrence.property_id === item.property_id
    );
    return {
      ...item,
      recurrence: recurrenceItem && recurrenceItem.recurrence,
    };
  });
  state.items.data = items;
}

function SET_INTERVENTIONS_IN_PROGRESS(state, interventionsList) {
  let items = state.items.data;
  items = items.map((item) => {
    const interventionItem = interventionsList.find(
      (intervention) => intervention.propertyId === item.property_id
    );
    return {
      ...item,
      interventions_in_progress: interventionItem ? interventionItem.list : [],
    };
  });
  state.items.data = items;
}

function openRecurrence({ commit, dispatch }, item) {
  dispatch('initCurrent', item.id);
  commit('SET_CURRENT_ACTIVE', item);
  dispatch(
    'boilerplate/setModalOpened',
    { component: 'RequestDialog', tab: 'recurrence' },
    { root: true }
  );
}

function openInterventions({ commit, dispatch }, item) {
  dispatch('initCurrent', item.id);
  commit('SET_CURRENT_ACTIVE', item);
  dispatch(
    'boilerplate/setModalOpened',
    { component: 'RequestDialog', tab: 'interventions' },
    { root: true }
  );
}

function assignOnOpen({ commit }) {
  commit('SET_ASSIGN', true);
}

function SET_ASSIGN(state, value) {
  state.active = { ...state.active, assign: value };
}

function SET_DISPATCHED(state, value) {
  state.active.data = { ...state.active.data, dispatched: value };
  const index = state.currents.findIndex(
    (el) => el.id === state.active.data.id
  );
  if (index >= 0) {
    state.currents[index].data = {
      ...state.currents[index].data,
      dispatched: value,
    };
  }
}

const requestsModule = (store) => {
  store.registerModule(
    ['requests'],
    makeSeveralCurrentsModule({
      attributesObj,
      attributesObjRef,
      customActions: {
        setTechnicianAffected,
        openRecurrence,
        openInterventions,
        assignOnOpen,
      },
      customMutations: {
        SET_ASSIGN,
        SET_DISPATCHED,
        SET_ALERTS,
        SET_RECURRENCE,
        SET_INTERVENTIONS_IN_PROGRESS,
      },
      customGetters: {
        assignActive: (state) => state.active.assign,
      },
      defaultSortBy: ['expiration'],
      hasDefaultFilters: true,
      serviceAPI: RequestsService,
      makeQueryParams: makeListRequest({
        useEntities: true,
      }),
    })
  );
};

export default requestsModule;
